import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "../../lib/site";

export default function Services() {
  const [active, setActive] = useState(0);

  return (
    <section id="services" className="relative bg-warm-white pt-8 pb-24 md:pt-12 md:pb-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal><Overline>Our Services</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl text-ocean-teal max-w-xl leading-tight">
                Premium property care, delivered with hospitality.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="font-sans font-light text-charcoal/70 max-w-xs">
              Eleven refined services, each treated as an experience — not a task.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Interactive list */}
          <div className="border-t border-border-stone">
            {SERVICES.map((s, i) => (
              <button
                key={s.title}
                data-testid={`service-item-${i}`}
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                className="group w-full text-left border-b border-border-stone py-5 md:py-6 flex items-baseline gap-5 transition-colors"
              >
                <span className={`font-sans text-xs tracking-widest transition-colors ${active === i ? "text-antique-gold" : "text-charcoal/40"}`}>
                  {s.n}
                </span>
                <span className="flex-1">
                  <span className={`font-serif text-2xl md:text-3xl transition-colors duration-300 ${active === i ? "text-ocean-teal" : "text-charcoal"}`}>
                    {s.title}
                  </span>
                  <AnimatePresence>
                    {active === i && (
                      <motion.span
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        className="block overflow-hidden font-sans font-light text-sm text-charcoal/60 mt-1"
                      >
                        {s.desc}
                      </motion.span>
                    )}
                  </AnimatePresence>
                </span>
              </button>
            ))}
          </div>

          {/* Preview image */}
          <div className="sticky top-28 hidden md:block h-[560px] overflow-hidden rounded-sm shadow-[0_30px_60px_-25px_rgba(10,75,84,0.25)]">
            <AnimatePresence mode="wait">
              <motion.img
                key={SERVICES[active].img}
                src={SERVICES[active].img}
                alt={SERVICES[active].title}
                initial={{ opacity: 0, scale: 1.06 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                className="absolute inset-0 h-full w-full object-cover"
              />
            </AnimatePresence>
            <div className="absolute inset-0 bg-gradient-to-t from-ocean-teal/30 to-transparent" />
            <div className="absolute bottom-6 left-6 text-warm-white">
              <span className="font-serif text-2xl">{SERVICES[active].title}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
